import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { concerns } from '../data/content';
import { treatments } from '../data/treatments';
import { useStore } from '../contexts/StoreContext';
export function ConcernFinder() {
  const [activeId, setActiveId] = useState(concerns[0].id);
  const {
    openBooking
  } = useStore();
  const active = concerns.find(c => c.id === activeId) ?? concerns[0];
  const treatment = treatments.find(t => t.name === active.treatment);
  return <section className="border-y border-line bg-shell py-16 lg:py-24" aria-labelledby="concern" data-id="element-92" data-mp="wtsqzkekqgos">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-93" data-mp="stijg3b4vi7t">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-94" data-mp="sr66k4k8fy1m">
          <div className="lg:col-span-5" data-id="element-95" data-mp="1pbomq6qkgu81">
            <p className="rule-label text-[11px] uppercase tracking-widest text-clay" data-id="element-96" data-mp="1kk6m5jsggvnl">
              Start hier
            </p>
            <h2 id="concern" className="mt-6 font-display text-4xl font-light leading-[1.08] text-ink sm:text-[2.9rem]" data-id="element-97" data-mp="1jr06xfik4xop">
              Waar loopt jouw huid
              <span className="italic text-clay" data-id="element-98" data-mp="1a203njx0vg4p"> tegenaan?</span>
            </h2>
            <p className="mt-5 max-w-md text-[15px] leading-relaxed text-muted" data-id="element-99" data-mp="1f0a1k2a4suu0">
              Kies wat het meest herkenbaar is. Je ziet direct welke behandeling en welke producten
              ik daarvoor zou inzetten.
            </p>

            <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-100" data-mp="160mzrfdhpn0f">
              {concerns.map(c => {
              const isActive = c.id === activeId;
              return <li key={c.id} data-id="element-101" data-mp="w2qpepsdmw3d">
                    <button type="button" aria-pressed={isActive} onClick={() => setActiveId(c.id)} className="group flex w-full items-center justify-between gap-4 py-4 text-left" data-id="element-102" data-mp="w3s2t0wv7uo9">
                      <span className={`font-display text-xl transition-colors duration-150 ease-soft ${isActive ? 'text-ink' : 'text-muted group-hover:text-ink'}`} data-id="element-103" data-mp="2ozuplxji7a0q">
                        {c.label}
                      </span>
                      <ArrowRightIcon className={`h-4 w-4 shrink-0 transition-all duration-200 ease-soft ${isActive ? 'translate-x-0 text-clay opacity-100' : '-translate-x-1 text-muted opacity-0 group-hover:translate-x-0 group-hover:opacity-100'}`} strokeWidth={1.5} data-id="element-104" data-mp="37p19hnw1a7o4" />
                    </button>
                  </li>;
            })}
            </ul>
          </div>

          <div className="lg:col-span-7" data-id="element-105" data-mp="3ln94hq9ieywn">
            <AnimatePresence mode="wait" data-id="element-106" data-mp="18662k3k2crln">
              <motion.article key={active.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex h-full flex-col justify-between bg-sand p-8 lg:p-10" data-id="element-107" data-mp="187hdqofu91ms">
                <div data-id="element-108" data-mp="1r5tq0j21qrml">
                  <p className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-clay" data-id="element-109" data-mp="1r48v2sbtl6o7">
                    <SparklesIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-110" data-mp="1w2k5p59xvl7h" />
                    Ons advies
                  </p>
                  <p className="mt-5 max-w-lg text-base leading-relaxed text-muted" data-id="element-111" data-mp="20x7k2bb8az8c">
                    {active.description}
                  </p>

                  <div className="mt-8 border-t border-line pt-6" data-id="element-112" data-mp="29wkt52vfxlsj">
                    <p className="text-[11px] uppercase tracking-widest text-muted" data-id="element-113" data-mp="2eucvyrxmisbi">
                      Behandeling
                    </p>
                    <h3 className="mt-2 font-display text-3xl font-light text-ink" data-id="element-114" data-mp="216kumwdi2g4i">
                      {active.treatment}
                    </h3>
                    {treatment && <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-115" data-mp="2awnoeysg3y3w">
                        {treatment.tagline} · {treatment.duration} ·{' '}
                        {treatment.kuur ?? treatment.price}
                      </p>}
                  </div>
                </div>

                <div className="mt-10 flex flex-wrap gap-3" data-id="element-116" data-mp="1db8g71xkc7iv">
                  <button type="button" onClick={() => openBooking(active.treatment)} className="group inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-117" data-mp="1s6xwqkjzbsg7">
                    Plan {active.treatment}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-soft group-hover:translate-x-0.5" strokeWidth={1.5} data-id="element-118" data-mp="2ypdyt3kpa9c2" />
                  </button>
                  <Link to="/webshop" className="inline-flex items-center gap-2 rounded-full border border-line px-6 py-3.5 text-sm text-ink transition-colors duration-150 ease-soft hover:border-ink" data-id="element-119" data-mp="2x6mc439pls11">
                    Producten voor {active.productSkinType.toLowerCase()}
                  </Link>
                </div>
              </motion.article>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}